// DS: UI08
import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { useScrollAware } from '@wix/da-hooks/pkg/useScrollAware';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { scrollTo } from '../utils/browser';
import s from './BackToTop.scss';
var DEFAULT_APPEAR_HEIGHT = 500;
// FEATURE CLEANUP: bye_back_to_top delete this file and its directory
var BackToTop = function (_a) {
    var _b = _a.offset, offset = _b === void 0 ? DEFAULT_APPEAR_HEIGHT : _b, allowInIframe = _a.allowInIframe, biTotalItemsCount = _a.biTotalItemsCount, className = _a.className, stuckClassName = _a.stuckClassName, _c = _a.scrollToY, scrollToY = _c === void 0 ? 0 : _c, scrollNode = _a.scrollNode;
    var _d = useState(typeof window !== 'undefined' &&
        (scrollNode ? scrollNode.scrollTop > offset : window.scrollY > offset)), isScrolled = _d[0], setIsScrolled = _d[1];
    var updateScrolled = useCallback(function (_a) {
        var scrollTop = _a.scrollTop;
        return setIsScrolled(scrollTop > offset);
    }, [offset]);
    useScrollAware(updateScrolled, scrollNode);
    var onClick = function () {
        var scrollOpts = {
            left: 0,
            top: scrollToY,
            behavior: 'smooth',
        };
        scrollTo(scrollNode || window, scrollOpts);
    };
    // prevent backtoTop inside iframes
    if (!allowInIframe &&
        typeof window !== 'undefined' &&
        window.top !== window.self) {
        ddt.error('backtotop', 'BackToTop wrongly embedded inside iframe. Use prop allowInIframe if you would like it to be shown');
        return null;
    }
    var button = (React.createElement(BiDiv, { biData: BiData({
            evid: 97,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            offset: biTotalItemsCount,
        }), onClick: onClick, className: classnames(s['root'], className, isScrolled && s['stuck'], isScrolled && stuckClassName) },
        React.createElement(ArrowUp, { size: IconSize.MEDIUM })));
    return button;
};
BackToTop.displayName = 'BackToTop';
export default BackToTop;
//# sourceMappingURL=BackToTop.js.map